export default {
  TOGGLE_CONTEXTUAL: 'menu/TOGGLE_CONTEXTUAL',
  TOGGLE_CANVAS_BLUR: 'menu/TOGGLE_CANVAS_BLUR'
};
